import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { SettingsMappingUsersRolesToDocWithDocNameEntity } from '../../../../../../api/types/settings/user-document-created-default/settings-user-role-doc-created-default';
import { getUserTypeDisplayTextName } from '../../../../../../api/types/user/user-type';
import { deleteDocumentRequirementOperation } from '../operations/delete-document-requirement-operation';

interface DeleteDefaultDocumentDialogProps {
  visible: boolean;
  onHide: () => void;
  documentData: SettingsMappingUsersRolesToDocWithDocNameEntity | null;
}

export const DeleteDefaultDocumentDialog: React.FC<
  DeleteDefaultDocumentDialogProps
> = ({ visible, onHide, documentData }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    if (!documentData) {
      return;
    }

    await deleteDocumentRequirementOperation(documentData.id, setLoading);
    onHide();
  };

  const handleDialogHide = () => {
    if (!loading) {
      onHide();
    }
  };

  return (
    <Dialog
      header="אישור מחיקה"
      visible={visible}
      onHide={handleDialogHide}
      style={{
        width: '450px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      modal
      closable={!loading}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          padding: '16px',
        }}
      >
        <div
          style={{
            textAlign: 'right',
            fontSize: '16px',
            marginBottom: '16px',
          }}
        >
          האם אתה בטוח שברצונך למחוק את המסמך הזה?
        </div>

        {documentData && (
          <div
            style={{
              backgroundColor: '#f8f9fa',
              padding: '12px',
              borderRadius: '8px',
              textAlign: 'right',
              border: '1px solid #e9ecef',
            }}
          >
            <div style={{ marginBottom: '8px' }}>
              <strong>תפקיד:</strong>{' '}
              {getUserTypeDisplayTextName(documentData.role)}
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>סוג מסמך:</strong> {documentData.docTypeName}
            </div>
            <div>
              <strong>שם המסמך:</strong> {documentData.docName}
            </div>
          </div>
        )}

        <div
          style={{
            backgroundColor: '#fff3cd',
            color: '#856404',
            padding: '12px',
            borderRadius: '8px',
            textAlign: 'right',
            border: '1px solid #ffeaa7',
            fontSize: '14px',
          }}
        >
          <strong>אזהרה:</strong> פעולה זו אינה ניתנת לביטול
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            marginTop: '16px',
          }}
        >
          <Button
            label="ביטול"
            severity="secondary"
            onClick={handleDialogHide}
            disabled={loading}
          />
          <Button
            label="מחק"
            severity="danger"
            onClick={handleConfirmDelete}
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};
